var map = {
	"./allday/ar.allday.json": [
		98122,
		8122
	],
	"./allday/en.allday.json": [
		75258,
		5258
	],
	"./app/ar.app.json": [
		71220
	],
	"./app/en.app.json": [
		48260
	],
	"./careem/ar.careem.json": [
		12202,
		2202
	],
	"./careem/en.careem.json": [
		2282,
		2282
	],
	"./instashop/ar.instashop.json": [
		98608,
		8608
	],
	"./instashop/en.instashop.json": [
		96944,
		6944
	],
	"./kaizen/ar.kaizen.json": [
		68286,
		8286
	],
	"./kaizen/en.kaizen.json": [
		98134,
		8134
	],
	"./rizek/ar.rizek.json": [
		43568,
		3568
	],
	"./rizek/en.rizek.json": [
		70224,
		224
	],
	"./sounder/ar.sounder.json": [
		47406,
		7406
	],
	"./sounder/en.sounder.json": [
		53078,
		3078
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8631;
module.exports = webpackAsyncContext;